"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PURCHASES = void 0;
var helpers_1 = require("../../client/helpers");
exports.GET_PURCHASES = "\n  query GetPurchases($cursor: String) {\n    purchases(cursor: $cursor, limit: 25) {\n        cursor\n        entities {\n            id\n            type\n            status\n            createdAt\n            expiresAt\n            metaSiteId\n            currency\n            price\n        }\n    }\n  }\n";
//# sourceMappingURL=purchases.queries.js.map